// src/app/worker-types/services/worker-type-upload.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

import { WorkerTypeImportRow } from './worker-type-import-row.model';

export interface CurrentUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  roles: { id: number; name: string }[];
  jobTitleRoles: any[];
  departmentRoles: any[];
  jobTitle: string | null;
  reportTo: string | null;
}

export interface WorkerTypeDto {
  name: string;
  description: string | null;
}

export interface WorkerType {
  id: number;
  name: string;
  description: string | null;
}

export interface ApiResponse<T> {
  status: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class WorkerTypeUploadService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  uploadRows(rows: WorkerTypeImportRow[]): Observable<WorkerType[]> {
    const payload: WorkerTypeDto[] = rows.map((r) => this.mapRowToApi(r));
    return this.http
      .post<ApiResponse<WorkerType[]>>(`${this.baseUrl}/api/worker-types/multiple`, payload)
      .pipe(map((res) => res.data));
  }

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.baseUrl}/api/account/get-current-user`);
  }

  private mapRowToApi(row: WorkerTypeImportRow): WorkerTypeDto {
    const name = (row.Name ?? '').toString().trim();
    const description =
      row.Description === null || row.Description === undefined
        ? null
        : row.Description.toString().trim();

    return {
      name,
      description: description?.length ? description : null,
    };
  }
}